export default "__VITE_ASSET__e45436ab__"